import { render, staticRenderFns } from "./OtherSettings.vue?vue&type=template&id=4968c952&scoped=true&"
import script from "./OtherSettings.vue?vue&type=script&lang=js&"
export * from "./OtherSettings.vue?vue&type=script&lang=js&"
import style0 from "./OtherSettings.vue?vue&type=style&index=0&id=4968c952&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4968c952",
  null
  
)

export default component.exports